import React from "react";
import "../App.css";
import { useTranslation } from "react-i18next";

export default function Video1() {
  const { t } = useTranslation();
  return (
    <div className="ow-video-wrap">
      <div className="ow-video-frame ow-video-frame-ratio">
        <iframe
          src="https://www.youtube.com/embed/8GmWaehczsg"
          title="Wajdi Bouallègue's routine at the 2004 DTB Cup semi final"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <p className="ow-video-caption">{t("routine1")}</p>
    </div>
  );
}
